import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

class BusinessLoactionsItem extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.generateTemplate = this.generateTemplate.bind(this); 
  }

  onClick() {
    this.props.onClick(this.props.value);
  }
  generateTemplate(text, highlight){
    if(highlight){
        const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
        const parsedString = <span>{parts.map(part => part.toLowerCase() === highlight.toLowerCase() ? <b>{part}</b> : part)}</span>;
        return parsedString;
    }else{
        return <span>{text}</span>
    }
}
getLabel=(label)=>{
  const { value } = this.props;
  const { brand_ids, studioId } = value;
  if(brand_ids && studioId && brand_ids.includes(studioId)){
    return 'All accounts';
  }else{
    return label;
  }

}

  render() {
    let item = (
      <NavLink to={this.props.path} className="dropdown-menu__item">
        {this.getLabel(this.props.label)}
      </NavLink>
    );

    const itemProps = {
      onClick: this.onClick,
    };

    if (this.props.type === 'BUTTON') {
      item = (
        <div
          className={classnames('dropdown-menu__item', this.props.className)}
          {...itemProps}
        >
          {this.generateTemplate(this.getLabel(this.props.label),this.props.search)}
        </div>
      );
    }

    return item;
  }
}

BusinessLoactionsItem.defaultProps = {
  label: '',
  path: '',
  type: 'LINK',
  onClick: () => {},
  value: '',
};

BusinessLoactionsItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  path: PropTypes.string,
  type: PropTypes.oneOf(['LINK', 'BUTTON']),
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BusinessLoactionsItem;
